import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isProductEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { isIPenPlatformDomainEntity, or } from '@ipen-portal/plugin-common';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { productTestResultApiRef } from './apis';

export const productTestResultPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'product-test-result-api',
      params: defineParams =>
        defineParams({
          apiRef: productTestResultApiRef,
          path: 'product-test-result',
        }),
    }),
    EntityCardBlueprint.make({
      name: 'test-result',
      params: {
        filter: or(isSolutionEntity, isProductEntity),
        loader: async () =>
          import('./components/TestResultComponent').then(m => (
            <m.TestResultComponent />
          )),
        type: 'info',
      },
    }),
    ...makeEntityContentWithToolbar({
      name: 'TestResultCardList',
      params: {
        filter: isIPenPlatformDomainEntity,
        icon: <Icon icon="material-symbols:check-circle" />,
        loader: async () =>
          import('./components/TestResultCardList').then(m => (
            <m.TestResultCardList />
          )),
        path: '/test-results',
        title: 'Test Results',
        toolbarElements: () =>
          import('@ipen-portal/plugin-common-react').then(
            m => m.PlatformStatusLegend,
          ),
      },
    }),
  ],
  pluginId: 'product-test-report',
});
